export default {
  'pages.workbench.defaultUser': 'ユーザー',
  'pages.workbench.enterpriseWorkspace': '企業ワークスペース',
  'pages.workbench.welcome': '{name}さん、おかえりなさい',
  'pages.workbench.welcomeDescription':
    'アプリ、基本サービス、運用をつなぎ、ここから今日の仕事を始めましょう。',
  'pages.workbench.refresh': 'ワークベンチを更新',
  'pages.workbench.openAppCenter': 'アプリを開く',
  'pages.workbench.partialError':
    '一部のデータを読み込めませんでした。利用可能な内容を表示しています。',
  'pages.workbench.retry': '再読み込み',
  'pages.workbench.overview': 'ワークスペースの概要',
  'pages.workbench.installedApps': '有効なアプリ',
  'pages.workbench.availableToTeam': '企業で利用可能な業務アプリ',
  'pages.workbench.myApps': 'マイアプリ',
  'pages.workbench.myAppsDescription':
    '企業で利用可能なアプリから、すぐに業務を開始',
  'pages.workbench.viewAll': 'すべて表示',
  'pages.workbench.enabled': '有効',
  'pages.workbench.openApp': '{name}を開く（新しいウィンドウ）',
  'pages.workbench.viewApp': '{name}を表示',
  'pages.workbench.noApps': '最初の企業向けアプリを有効にする',
  'pages.workbench.noAppsDescription':
    'アプリマーケットでチームに合うツールを見つけ、業務の連携をスムーズにしましょう。',
  'pages.workbench.appsError': 'アプリ一覧を一時的に利用できません',
  'pages.workbench.retryDescription':
    '再読み込みするか、該当するセンターでご確認ください。',
  'pages.workbench.browseMarket': 'アプリマーケットを見る',
  'pages.workbench.resourceOverview': 'リソースの概要',
  'pages.workbench.resourceOverviewDescription':
    '現在のワークスペースのクラスターリソース使用量',
  'pages.workbench.cpu': 'CPU',
  'pages.workbench.memory': 'メモリ',
  'pages.workbench.cores': 'コア',
  'pages.workbench.gib': 'GiB',
  'pages.workbench.notConnected': '未接続',
  'pages.workbench.unavailable': 'データなし',
  'pages.workbench.resourceUsage': '{used} / {total} {unit} 使用中',
  'pages.workbench.connectClusterDescription':
    '企業のクラスターを接続するとリソース使用量を確認できます',
  'pages.workbench.openMonitoring': 'リソース監視を開く',
  'pages.workbench.guideTitle': 'さらなる可能性を探る',
  'pages.workbench.guideDescription':
    'チームに合うアプリと機能を見つけましょう。',
  'pages.workbench.guide.apps': '業務アプリを探す',
  'pages.workbench.guide.appsDescription':
    '企業向けアプリを探し、チームのツールを拡充',
  'pages.workbench.footer': '企業向けデジタル・AI オペレーティングシステム',
  'pages.workbench.deployments': 'マイデプロイ',
  'pages.workbench.deploymentsInCluster': '企業クラスタで稼働するサービス',
  'pages.workbench.clusterNodes': 'クラスタノード',
  'pages.workbench.readyNodes': 'Ready のノード',
  'pages.workbench.runningPods': '稼働中の Pod',
  'pages.workbench.podsInCluster': 'クラスタ内で稼働中の Pod',
  'pages.workbench.deploymentsPanel': 'マイデプロイ',
  'pages.workbench.deploymentsPanelDescription':
    '企業クラスタにデプロイされたアプリとサービス',
  'pages.workbench.allDeployments': 'すべてのデプロイ',
  'pages.workbench.noDeployments': 'デプロイはまだありません',
  'pages.workbench.noDeploymentsDescription':
    'デプロイテンプレートからワンクリックでデプロイするか、カスタムイメージをデプロイできます。',
  'pages.workbench.deploymentsError': 'デプロイ一覧を一時的に利用できません',
  'pages.workbench.openAppStore': 'デプロイテンプレートを開く',
  'pages.workbench.guide.appStore': 'クラウドネイティブアプリをデプロイ',
  'pages.workbench.guide.appStoreDescription':
    'データベース、監視ツール、カスタムコンテナをワンクリックで',
};
